import { useRef } from 'react'

let mouseDownTime = 0
let dragStarted = false
const DELTA_LIMIT = 150

export const useDragToScroll = () => {
  const pos = useRef(null)

  const onMouseDown = e => {
    dragStarted = true
    mouseDownTime = new Date().getTime()

    e.preventDefault()

    const el = e.currentTarget

    pos.current = {
      left: el.scrollLeft ?? 0,
      top: el.scrollTop ?? 0,
      x: e.clientX,
      y: e.clientY,
    }

    el.classList.remove('dragging')
  }

  const onMouseMove = e => {
    const delta = new Date().getTime() - mouseDownTime
    if (delta < DELTA_LIMIT || !dragStarted) return

    if (!pos.current || e.buttons !== 1) return
    e.preventDefault()

    const el = e.currentTarget

    const dx = e.clientX - pos.current.x
    const dy = e.clientY - pos.current.y

    el.scrollTop = pos.current.top - dy
    el.scrollLeft = pos.current.left - dx

    el.classList.add('dragging')
  }

  const onMouseUp = e => {
    mouseDownTime = 0
    dragStarted = false
    e.preventDefault()
    pos.current = null
    const el = e.currentTarget
    el.classList.remove('dragging')
  }

  return {
    onMouseDown,
    onMouseMove,
    onMouseUp,
    onMouseLeave: onMouseUp,
  }
}
